<template>

  <div id="detail">
    <div>
      <div class="large-12 medium-12 small-12 columns"><p></p>
          <h2>ZOBRAZUJEM: {{ readMsisdn }}</h2>
          <hr> </div>
      <div class="large-12 medium-12 small-12 columns"> <img class="leftIco inline" src="graphics/ico_sum.png" /> <span class="midleLabel inline fet">Aktuálny kredit</span>
          <h5 class="right">{{ creditGeneral.toString().replace(/\./, ',') +" €" }}</h5>
      </div>
      <div class="large-12 medium-12 small-12 columns"><hr class="btm">
          <span class="left"><strong>Kredit</strong>
          </span>
          <span class="right">{{ creditNominal.toString().replace(/\./, ',') +" €" }}
          </span>
      </div>
      <div class="large-12 medium-12 small-12 columns">
          <span class="left" v-html="tpl('credit.detailValidity.nominal')"></span>
          <span class="right">{{ moment((filterBouquet('General Cash').endDate) || (productdetail.product.endDate)).format('D.M.YYYY') }}</span>
      </div>
      <div class="large-12 medium-12 small-12 columns xspace">
          <span class="left"><strong>Bonusový kredit</strong>
          </span>
          <span class="right">{{ Math.abs(creditGeneral - creditNominal).toFixed(2).toString().replace(/\./, ',') +" €" }}
          </span>
      </div>
      <div class="large-12 medium-12 small-12 columns ">
          <span class="left" v-html="tpl('credit.detailValidity.bonus')"></span>
          <span class="right">{{ moment((filterBouquet('Promotional Cash').endDate) || (productdetail.product.endDate)).format('D.M.YYYY') }}</span>
      </div>
      <div class="large-12 medium-12 small-12 columns xspace">
          <span class="left">Stav kreditu k</span>
          <span class="right" >{{ moment(Number(productdetail.timeStamp)).format('D.M.YYYY H:mm') }}</span>
      </div>

      <div v-if="bannerInterval.visible" class="large-12 medium-12 small-12 columns xspace">
        <router-link :to="bannerInterval.href"><img :src="bannerInterval.target" /></router-link>
      </div>
      <div v-if="states.lastReload">
      <div class="large-12 medium-12 small-12 columns"><hr/>
         <img class="leftIco inline" src="graphics/ico_cal.png" /> <span class="midleLabel inline">Posledné dobitie kreditu</span>
      </div>
      <div class="large-12 medium-12 small-12 columns xspace">
          <span class="left">Platba
          </span>
          <span class="right">{{lastRecharge('amount')}}
          </span>
      </div>
      <div class="large-12 medium-12 small-12 columns">
          <span class="left">Dátum
          </span>
          <span class="right">{{lastRecharge('date')}}
          </span>
      </div>
</div>
    </div>      

  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'detail',
  props: ['productdetail', 'tplData', 'states', 'filterBouquet'],
  data () {
    return {
      msg: 'Detail',
      tpl: function(tpath) {
        const inObj = _.get(this.tplData, tpath); var res = null
        if (inObj) {res = inObj
        } else {
          res = tpath.toString()
        } return res
      },
      moment:moment,
      eligData: {}
    }
  },
  created: async function() {
    var that = this
    window.history.pushState(null, '')
    window.onpopstate = function(event) {
    window.history.replaceState(null, '')
    that.states.mainView = true 
    that.states.detailView = false
    }

    if (!_.isEmpty(this.$store.state.localEligData)) {
      this.eligData = { data: this.$store.state.localEligData, status: 200 }
    } else {
      const elRes = await this.httpEligible();
      if (elRes.status === 200) {
        that.$store.commit('localEligData', elRes.data);
        this.eligData = elRes;
      }
    }
  },
  mounted: function() {
  if (!_.isUndefined(this.productdetail.product.creditData)) {
    if (!_.isEmpty(this.productdetail.product.creditData.lastRechargeDate)) {
      if (moment(this.productdetail.product.creditData.lastRechargeDate).add(13, 'months') > moment()) {
        this.states.lastReload = true
      }
    }        
  }        
  },
  methods: {
    lastRecharge: function (s) {
     var res = "0"
      if (s == "date") {
        if (moment(this.productdetail.product.creditData.lastRechargeDate).add(13, 'months') > moment()) {
        this.states.lastReload = true
          res = moment(this.productdetail.product.creditData.lastRechargeDate).format('D.M.YYYY')
        }
      }
      if (s == "amount") {
        res = parseFloat(this.productdetail.product.creditData.lastRechargeAmount).toFixed(2).toString().replace(/\./, ',') + " €"
      }
     return res
    },
    httpEligible: async function() {
      let a 
      await this.$http.get(this.$store.state.elgSrc)
      .then(function (resp) {
         a = { data: resp.data, status: resp.status }
      })
      .catch(function(err){
         a = { data: err.response.data, status: err.response.status }
      })
      return a
    },
    findIntAbs: function(potential) {
      if (potential === undefined || isNaN(potential)) {
        return 0;
      } else {
        const nr = parseInt(potential)
        let res = nr;
        if (res < 0) { res = 0 };
        return res;
      }
    }
  },
  computed: {
    readMsisdn: function() {
      if (String(this.productdetail.msisdn).length > 8) {
        return '0' + String(this.productdetail.msisdn).substring(3)
      }
      else {
        return ''
      }
    },
    creditGeneral: function() {
      const cGeneral = this.findIntAbs(this.filterBouquet('General Cash').value);
      const cPromo = this.findIntAbs(this.filterBouquet('Promotional Cash').value);
      return (Math.round((cGeneral + cPromo)  / 1000) / 100).toFixed(2)
    },
    creditNominal: function() {
      const cGeneral = this.findIntAbs(this.filterBouquet('General Cash').value);
      return (Math.round(cGeneral  / 1000) / 100).toFixed(2)
    },
    bannerInterval: function() {
      var ret = { visible: false, target: '//static.telekom.sk/prepaid/img/xmass24_mixi.png', href: '/kredit' }
      if (this.productdetail.product?.productNumber !== 'PR1920') {
        try {
          var bannerJSONObj = JSON.parse(this.tplData.general.bannerJSONString);
          ret.target = '//static.telekom.sk/prepaid/img/' + bannerJSONObj.img;
          if (!_.isEmpty(bannerJSONObj.target)) {
            ret.href = bannerJSONObj.target;
          }
          ret.visible = (moment(Number(this.productdetail.timeStamp)).isBefore(moment(bannerJSONObj.to)) && moment(Number(this.productdetail.timeStamp)).isAfter(moment(bannerJSONObj.from)));
        } catch(e) {
          console.error('tpl obj general.bannerJSONString error:', e.message)
        }
      }
      // if (this.eligData.data) {
      //   if (_.filter(this.eligData.data, { bucketName: '1000GB'} ).length > 0) {
      //     ret.href = '/balicky?pkg=1000GB'
      //     ret.target = '//static.telekom.sk/prepaid/img/xmass23_data.jpg';
      //   }
      // }
      return ret;
    }
  }
}
</script>

<style scoped>
.xspace {
  margin-top: 0.7rem;
}

hr.btm {
  margin-bottom: 0.3rem;
}
</style>
